// Radha — a small reusable bar chart for the module panels (M4).
//
// One chart component the rich panels share, wired to live data. Pass a title and
// a {label, value}[]; money formats the axis/tooltip as ₹, and colors can be a
// single hue or a per-label map for severity.
import React from "react";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, CartesianGrid,
} from "recharts";

import { fmtMoney as inr } from "../lib/money";


export function ModuleChart({
  title, data, money = false, color = "var(--accent-purple)", colorMap,
}: {
  title: string;
  data: { label: string; value: number }[];
  money?: boolean;
  color?: string;
  colorMap?: Record<string, string>;
}) {
  if (data.length === 0) return null;
  return (
    <div style={{ height: 180, margin: "4px 0 22px" }}>
      <div style={{ font: "600 13px Inter", color: "var(--fg-muted)", marginBottom: 6 }}>{title}</div>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 4, right: 8, bottom: 0, left: 8 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--surface-2)" vertical={false} />
          <XAxis dataKey="label" tick={{ fontSize: 12, fill: "var(--fg-muted)" }} axisLine={false} tickLine={false} />
          <YAxis
            tickFormatter={(v) => (money ? inr(v) : String(v))}
            tick={{ fontSize: 11, fill: "var(--fg-muted)" }} axisLine={false} tickLine={false} width={money ? 52 : 32} />
          <Tooltip formatter={(v: number) => (money ? inr(v) : v)} cursor={{ fill: "var(--surface-2)" }}
            contentStyle={{ fontSize: 12, borderRadius: 8, border: "1px solid var(--border)", background: "var(--surface)", color: "var(--fg)" }}
            labelStyle={{ color: "var(--fg)" }} itemStyle={{ color: "var(--fg)" }} />
          <Bar dataKey="value" radius={[4, 4, 0, 0]}>
            {data.map((d) => <Cell key={d.label} fill={colorMap?.[d.label] ?? color} />)}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
